// src/App.tsx
import React from 'react';
import DownloadButtons from './DownloadButtons';

const App: React.FC = () => {
  return (
    <div className="App">
      <DownloadButtons />
    </div>
  );
};

export default App;
